var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.canSync && _vm.$can(_vm.$permissions.FOODCARD_SYNC_EXTERNAL))?_c('VBtn',{attrs:{"primary":""},on:{"click":_vm.syncAllFoodcards}},[_vm._v(" "+_vm._s(_vm.$t('venue.form.externalOrderProviders.syncAllFoodcards'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }